/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactElement, useEffect, useState } from 'react';
import gridStyle from '@pages/forms/Grid.module.scss';
import SearchBox from '@components/SearchBox/SearchBox';
import { iSponsor } from '@interfaces/interfaces';
import { getWDPData } from '@api/APIServices';
import TabComponent from '@components/Tabs/TabComponent';

import { Alert, FormLoading, wdpLoading } from '@components/index';
import styles from './WDPSponsorSearch.module.scss';
import SearchBySuburb from './SearchBySuburb';
import SearchBySponsor from './SearchBySponsor';

function WDPSponsorSearch(): ReactElement {
  const [loading, setLoading] = useState(true); // THIS WILL BE CHANGED TO TRUE
  const [error, setError] = useState(false);
  const [data, setData] = useState<iSponsor[]>([]);

  useEffect(() => {
    try {
      getWDPData()
        .then((responseBody) => {
          setData(responseBody);
        })
        .catch((e) => console.log(e));
      setLoading(false);
    } catch (ex) {
      setError(true);
      console.log('error');
    }
    return () => {
      setLoading(false);
    };
  }, []);

  const tabs = [
    {
      label: 'Search by suburb',
      content: <SearchBySuburb data={data} />,
      id: 'wdp-search-by-suburb',
    },
    {
      label: 'Search by sponsor',
      content: <SearchBySponsor data={data} />,
      id: 'wdp-search-by-sponsor'
    },
  ];

  return (
    <>
      <div className={styles.wdpContainer}>
        {loading && <FormLoading />}
        {!loading && (
          <div>
            <TabComponent tabs={tabs} />
            {error && <Alert title="" message="Something went wrong on our end. Please try again later." theme="error" />}
          </div>
        )}
      </div>
    </>
  );
}

export default WDPSponsorSearch;
